import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";

import { AppWrap, MotionWrap } from "../../wrapper";
// import { urlFor, client } from "../../client";

import "./Testimonial.scss";

const Testimonial = () => {
  const [brands, setBrands] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  useEffect(() => {
    // const query = '*[_type == "testimonials"]';
    // const brandsQuery = '*[_type == "brands"]';

    // client.fetch(query).then((data) => {
    //   setTestimonials(data);
    // });

    // client.fetch(brandsQuery).then((data) => {
    //   setBrands(data);
    //   brands.map((brand) => {
    //   	console.log("assets: ", brand.imgUrl);
    //   });
    // });
  }, []);

  return (
    <>
      {/* {testimonials.length && (
        <>
          <div className='app__testimonial-item app__flex'>
            <img
              src={urlFor(testimonials[currentIndex].imageurl.asset._ref)}
              alt={testimonials[currentIndex].name}
            />

            <div className='app__testimonial-content'>
              <p className='p-text'>{testimonials[currentIndex].feedback}</p>
              <div>
                <h4 className='bold-text'>{testimonials[currentIndex].name}</h4>
                <h5 className='bold-text'>
                  {testimonials[currentIndex].company}
                </h5>
              </div>
            </div>
          </div>

          <div className='app__testimonial-btns app__flex'>
            <div
              className='app__flex'
              onClick={() =>
                handleClick(
                  currentIndex === 0
                    ? testimonials.length - 1
                    : currentIndex - 1
                )
              }>
              <HiChevronLeft />
            </div>
            <div
              className='app__flex'
              onClick={() =>
                handleClick(
                  currentIndex === testimonials.length - 1
                    ? 0
                    : currentIndex + 1
                )
              }>
              <HiChevronRight />
            </div>
          </div>
        </>
      )} */}

        <div className='app__testimonial-item app__flex'>
          <img
            src={"https://cdn.sanity.io/images/401mjdck/production/33f6e2054349d57d66196ed5b79b88770577507c-857x1284.jpg"}
            alt={"Muhammad Khizar Khan"}
          />

          <div className='app__testimonial-content'>
            <p className='p-text'>Great job, recommended!</p>
            <div>
              <h4 className='bold-text'>Muhammad Khizar Khan</h4>
              <h5 className='bold-text'>
                UI/UX Designer
              </h5>
            </div>
          </div>
        </div>

        <div className='app__testimonial-btns app__flex'>
          <div
            className='app__flex'
            onClick={() =>
              handleClick(
                1
              )
            }>
            <HiChevronLeft />
          </div>
          <div
            className='app__flex'
            onClick={() =>
              handleClick(
                0
              )
            }>
            <HiChevronRight />
          </div>
        </div>

      {/* <div className='app__testimonial-brands app__flex'>
        {brands.map(
          (brand) =>
            brand.imgUrl.asset && (
              <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5, type: "tween" }}
                key={brand._id}>
                <img src={urlFor(brand.imgUrl.asset._ref)} alt={brand.name} />
              </motion.div>
            )
        )}
      </div> */}

      <div className='app__testimonial-brands app__flex'>
        <motion.div
          whileInView={{ opacity: [0, 1] }}
          transition={{ duration: 0.5, type: "tween" }}>
          <img src={"https://cdn.sanity.io/images/401mjdck/production/4515ff94bdf4c0f502bff9a209a70a2526a3cdde-400x400.png"} alt={"interns pakistan"} />
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Testimonial, "app__testimonial"),
  "testimonial",
  "app__primarybg"
);
